import { useTranslate } from '@tolgee/react';
import { updateProductKnowledge } from '../../productKnowledge/api/productKnowledge';
import type { ProductKnowledgeScopeSnapshot } from '../../productKnowledge/model/types';
import { KnowledgeEditModal } from '../../productKnowledge/components/KnowledgeEditModal';

/**
 * 新版商品知识（商详 V2 / 文档知识）的引用编辑弹框：
 * 复用商品知识模块的 KnowledgeEditModal，问题只读，答案、范围、启用开关均可编辑。
 * 点保存直接调用知识库 PUT（范围变更由 DocumentScopeEditor 即时落库），不走会话暂存链路。
 */
export default function CiteProductKnowledgeEditModal({
  knowledgeType,
  knowledgeId,
  question,
  answer,
  scope,
  extraQuestions,
  enabled,
  onSaved,
  onCancel,
}: {
  knowledgeType: 'SPU_DETAIL_KNOWLEDGE' | 'DOCUMENT_KNOWLEDGE';
  knowledgeId: string | number;
  question: string;
  answer: string;
  scope: ProductKnowledgeScopeSnapshot;
  extraQuestions: string[];
  enabled: boolean;
  onSaved: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslate();
  const isDocument = knowledgeType === 'DOCUMENT_KNOWLEDGE';
  return (
    <KnowledgeEditModal
      visible
      title={t('修改引用知识')}
      question={question}
      knowledgeId={knowledgeId}
      scopeVariant={isDocument ? 'document' : 'products'}
      showEnableToggle
      initialValues={{ answer, scope, enabled }}
      onCancel={onCancel}
      onSubmit={async ({ answer: nextAnswer, enabled: nextEnabled }) => {
        if (isDocument) {
          await updateProductKnowledge('DOCUMENT_KNOWLEDGE', knowledgeId, {
            answer: nextAnswer,
            enable: nextEnabled,
          });
        } else {
          await updateProductKnowledge('SPU_DETAIL_KNOWLEDGE', knowledgeId, {
            question,
            answer: nextAnswer,
            extraQuestions,
            enable: nextEnabled,
          });
        }
        onSaved();
      }}
    />
  );
}
